import "app/styles/index.scss";
import {createRoot} from "react-dom/client";
import App from "app/App";
import {BrowserRouter} from "react-router-dom";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);